import { render, staticRenderFns } from "./DeleteConfirmDialog.vue?vue&type=template&id=ac4b2914&scoped=true"
import script from "./DeleteConfirmDialog.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteConfirmDialog.vue?vue&type=style&index=0&id=ac4b2914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4b2914",
  null
  
)

export default component.exports